import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  actions: {
    async fetchReviews(_, params) {
      return axiosIns.get(`/reviews/${params.reviewableType}/${params.reviewableId}`)
    },
    changeReviewStatus(_, {
      reviewableType, reviewableId, externalId, status,
    }) {
      return axiosIns.patch(`reviews/${reviewableType}/${reviewableId}`, {
        externalId,
        status,
      })
    },
  },
}
